import React from "react";
import { useNavigate } from "react-router-dom";

interface CustomErrorPageProps {
  errorCode?: number;
  errorMessage?: string;
}

const CustomErrorPage: React.FC<CustomErrorPageProps> = ({
  errorCode = "",
  errorMessage = "",
}) => {
  const navigate = useNavigate();

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
        backgroundColor: "#f2f4f8",
        padding: "1rem",
      }}
    >
      <div
        style={{
          background: "#fff",
          borderRadius: "12px",
          padding: "3rem 2rem",
          boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
          textAlign: "center",
          maxWidth: "500px",
          width: "100%",
        }}
      >
        <h1 style={{ fontSize: "2rem", color: "#333", marginBottom: "0.5rem" }}>
          Oops! Something went wrong.
        </h1>
        <h2
          style={{ fontSize: "1.5rem", color: "#007BFF", marginBottom: "1rem" }}
        >
          {/* Error {errorCode} */}
        </h2>
        <p style={{ color: "#555", marginBottom: "2rem" }}>{errorMessage}</p>
        <button
          onClick={() => {
            navigate("/RequestDashboard");
            window.location.reload(); // not ideal, but ensures clean state
          }}
          style={{
            padding: "12px 24px",
            fontSize: "16px",
            backgroundColor: "#007BFF",
            color: "#fff",
            border: "none",
            borderRadius: "6px",
            cursor: "pointer",
            transition: "background-color 0.3s ease",
          }}
          onMouseOver={(e) => {
            (e.currentTarget as HTMLButtonElement).style.backgroundColor =
              "#0056b3";
          }}
          onMouseOut={(e) => {
            (e.currentTarget as HTMLButtonElement).style.backgroundColor =
              "#007BFF";
          }}
          onFocus={(e) => {
            (e.currentTarget as HTMLButtonElement).style.backgroundColor =
              "#0056b3";
          }}
          onBlur={(e) => {
            (e.currentTarget as HTMLButtonElement).style.backgroundColor =
              "#007BFF";
          }}
        >
          Go Back Home
        </button>
      </div>
    </div>
  );
};

export default CustomErrorPage;
